import {
  useCheckoutSessionCompletedMutation,
  useGetCheckoutSessionQuery,
} from '@diditusa/shared/api/checkoutApi';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoadUserQuery } from '@diditusa/shared/api/sessionApi';
import JobsApi from '@diditusa/shared/api/jobsApi';
import { format } from 'date-fns';
import styles from './CheckoutResult.module.css';
import { Job } from '@diditusa/shared/types/jobTypes';

export default function CheckoutResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const sessionId = new URLSearchParams(location.search).get('session_id');
  const { data: sessionStatus, ...getSessionState } = useGetCheckoutSessionQuery(sessionId!);
  const [setCheckoutSessionCompleted, _setCheckoutSessionCompletedState] =
    useCheckoutSessionCompletedMutation();
  const { data: user, ...loadUserState } = useLoadUserQuery();
  const { data: jobs, ...loadJobsState } = JobsApi.useGetJobsQuery();
  const [getJob, { data: job, ...getJobState }] = JobsApi.useLazyGetJobQuery();
  const [sortedJobs, setSortedJobs] = useState<Job[]>([]);

  // useEffect(() => {
  //   if (!loadJobsState.isLoading && jobs) {
  //     const now = new Date();

  //     // Filter for future jobs only
  //     const upcomingJobs = jobs.filter((job) => job.startTime.toJSDate() > now);

  //     // Find the single soonest upcoming job
  //     const soonestJob = upcomingJobs.reduce((soonest, current) => {
  //       return current.startTime.toJSDate() < soonest.startTime.toJSDate() ? current : soonest;
  //     }, upcomingJobs[0]);

  //     // Set the single job in an array if one exists
  //     setSortedJobs(soonestJob ? [soonestJob] : []);
  //   }
  // }, [loadJobsState.isLoading, jobs]);

  useEffect(() => {
    if (!sessionId) {
      return;
    }

    if (!sessionStatus) {
      return;
    }

    getJob(parseInt(sessionStatus.jobId!));

    if (sessionStatus?.status === 'complete') {
      setCheckoutSessionCompleted({ sessionId });
    }
  }, [sessionStatus?.status, sessionId, setCheckoutSessionCompleted]);

  if (!sessionId) {
    return <p>No checkout found...</p>;
  }

  if (getSessionState.isLoading || getJobState.isLoading || getJobState.isUninitialized) {
    return <LoadingIndicator isVisible={true} />;
  }

  if (getSessionState.isError) {
    return <p>Error getting session {(getSessionState.error as any).data.message}</p>;
  }

  if (sessionStatus && sessionStatus.status === 'open') {
    if (sessionStatus.jobId) {
      navigate(`/checkout/${sessionStatus.jobId}`);
    } else {
      console.log('Payment failed but no jobId was included');
      return <p>There was an error processing the payment. Try again later...</p>;
    }
  }

  // const format12Hour = (h: string, m: string, ampm: 'AM' | 'PM') => `${h}:${m} ${ampm}`;

  if (sessionStatus && job) {
    // return <p>Thank you for your order! A confirmation email will be sent shortly.</p>;
    // return <img src='/PaymentConfirmed.png' width={'500px'} />;
    return (
      <div className={styles.container}>
        <div className={styles.header}>Payment confirmed ✅</div>

        <p className={styles.message}>
          <strong>Thank you for staying SAëF!</strong> <br />
          Your protection:
        </p>
        <div className={styles.details}>
          <div className={styles.jobItem}>
            Location: <strong>{job.location || '{ blank }'}</strong>
            <br />
            Date: <strong>{job.startTime.toFormat('MM/dd/yyyy')}</strong>
            <br />
            Time:{' '}
            <strong>{job.startTime.toFormat('hh:mm a ZZZZ') + ' Las Vegas Local Time'}</strong>
            <br />
            Duration:{' '}
            <strong>{job.durationHours ? `${job.durationHours} hours` : '{ blank }'}</strong>
            <br />
            Additional instructions: <strong>{job.description || '{ blank }'}</strong>
            <br />
            <button className={styles.infoButton}> What comes next? </button>
          </div>
        </div>
        <button onClick={() => navigate('/')} className={styles.button}>
          Back to Home
        </button>
      </div>
    );
  }

  return <div>Error! Unknown state. Try again later...</div>;
}
